import { render, staticRenderFns } from "./admin-file.vue?vue&type=template&id=2654d09c"
import script from "./admin-file.vue?vue&type=script&lang=js"
export * from "./admin-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports